import { render, staticRenderFns } from "./AgentSalesNumberDisplayer.vue?vue&type=template&id=10320fdc"
import script from "./AgentSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./AgentSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports